<ul class="sidebar-nav-list">
  <li class="sidebar-nav-item">

    <div routerLinkActive="active-item" routerLink="/monitor" class="row sidebar-nav-row">

      <div
        [ngClass]="{'icon-minimized': sidebarMinimized}"
        class="sidebar-nav-item-icon holding-icon"
      ></div>

      <p [ngClass]="{'none': sidebarMinimized}" class="menu-text">Monitor</p>

    </div>

  </li>

  <li class="sidebar-nav-item">

    <div routerLinkActive="active-item" routerLink="/company" class="row sidebar-nav-row">

      <div
        [ngClass]="{'icon-minimized': sidebarMinimized}"
        class="sidebar-nav-item-icon company-icon"
      ></div>

      <p [ngClass]="{'none': sidebarMinimized}" class="menu-text">Empresas</p>

    </div>

  </li>

  <li class="sidebar-nav-item">

    <div routerLinkActive="active-item" routerLink="/holding" class="row sidebar-nav-row">

      <div
        [ngClass]="{'icon-minimized': sidebarMinimized}"
        class="sidebar-nav-item-icon holding-icon"
      ></div>

      <p [ngClass]="{'none': sidebarMinimized}" class="menu-text">Grupos</p>

    </div>

  </li>

  <li class="sidebar-nav-item">

    <div routerLinkActive="active-item" routerLink="/version" class="row sidebar-nav-row">

      <div
        [ngClass]="{'icon-minimized': sidebarMinimized}"
        class="sidebar-nav-item-icon version-icon"
      ></div>

      <p [ngClass]="{'none': sidebarMinimized}" class="menu-text">Versões</p>

    </div>

  </li>

  <li class="sidebar-nav-item">

    <div routerLinkActive="active-item" routerLink="/user" class="row sidebar-nav-row">

      <div
        [ngClass]="{'icon-minimized': sidebarMinimized}"
        class="sidebar-nav-item-icon user-icon"
      ></div>

      <p [ngClass]="{'none': sidebarMinimized}" class="menu-text">Usuários</p>

    </div>

  </li>


</ul>

<div (click)="logout()" [ngClass]="{'exit-btn-minimized': sidebarMinimized}" routerLink="/auth" class="row sidebar-nav-row exit-btn">

  <div
    [ngClass]="{'icon-minimized': sidebarMinimized}"
    class="sidebar-nav-item-icon exit-icon"
  ></div>

  <p [ngClass]="{'none': sidebarMinimized}" class="menu-text">Sair</p>

</div>
